import { render, staticRenderFns } from "./assetsIndex.vue?vue&type=template&id=180cb43c&scoped=true&"
import script from "./assetsIndex.vue?vue&type=script&lang=js&"
export * from "./assetsIndex.vue?vue&type=script&lang=js&"
import style0 from "./assetsIndex.vue?vue&type=style&index=0&id=180cb43c&scoped=true&lang=css&"
import style1 from "./assetsIndex.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180cb43c",
  null
  
)

export default component.exports